<template>
  <div class="card floating">
    <div class="card-title">
      <h2>{{ $t('prompts.modify') }}</h2>
    </div>

    <div class="card-content" v-if="item">
      <p>{{ $t('backups.cron') }} (<code>{{ item.cron.slice(2) }}</code>):
        <a href="https://crontab.cronhub.io/" target="_blank" style="vertical-align: middle;"><InfoIcon/></a>
      </p>
      <input class="input input--block" v-focus type="text" v-model.trim="cron">
      <small>{{ humanCron }}</small>

      <p>{{ $t('backups.keep') }} (<code>{{ item.maxsnapshots }}</code>):</p>
      <input class="input input--block" type="number" min="0" v-model.trim="maxsnapshots">

      <p>{{ $t('backups.status') }} (<code>{{ itemStatus }}</code>):</p>
      <select class="input input--block" v-model="status">
        <option :value="0">{{ $t('sharedDrive.enabled') }}</option>
        <option :value="1">{{ $t('sharedDrive.disabled') }}</option>
      </select>
    </div>

    <div class="card-action">
      <button class="button button--flat button--grey" id ="buttonCancelRename"
        @click="$store.commit('closeHovers')"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')">{{ $t('buttons.cancel') }}</button>
      <button @click="submit" id ="buttonRename"
        class="button button--flat"
        type="submit" :disabled="!cronOk"
        :aria-label="$t('buttons.update')"
        :title="$t('buttons.update')">{{ $t('buttons.update') }}</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import cronstrue from 'cronstrue/i18n';
import { InfoIcon } from 'vue-feather-icons';

export default {
    name: 'modify-backup',
    data() {
        return {
            item: null,
            cron: '',
            maxsnapshots: 0,
            humanCron: '',
            cronOk: true,
            status: Module.BackupStatus.ENABLED.value,
        };
    },
    mounted() {
        this.setIsPrompt(true);
        this.item = this.getItem();
        if (this.item) {
            this.cron = this.item.cron.slice(2);
            this.maxsnapshots = this.item.maxsnapshots;
            this.status = this.item.status;
        }
    },
    watch: {
        cron(value) {
            if (value) {
                try {
                    this.humanCron = cronstrue.toString(value);
                    this.cronOk = true;
                }
                catch (e) {
                    this.humanCron = this.$t('prompts.error');
                    this.cronOk = false;
                }
            }
        }
    },
    computed: {
        ...mapState(['req', 'selected', 'selectedCount']),
        ...mapGetters(['isListing', 'isBackup']),
        itemStatus() {
            if (!this.item)
                return '';
            switch (this.item.status) {
                case Module.BackupStatus.ENABLED.value:
                    return this.$t('sharedDrive.enabled');
                case Module.BackupStatus.DISABLED.value:
                    return this.$t('sharedDrive.disabled');
                default:
                    return '';
            }
        }
    },
    methods: {
        ...mapMutations(['setIsPrompt']),
        getItem() {
            if (this.isBackup && window.location.hash !== '') {
                if (this.req.items[this.selected[0]] !== null && this.selected.length !== 0) {
                    return this.req.items[this.selected[0]];
                }
            }
            return null;
        },
        cancel() {
            this.$store.commit('closeHovers');
        },
        async submit() {
            const action = await ibb.modifyBackup(this.item.handle, this.item.name, +this.item.stime, '0 ' + this.cron, this.item.lpath, +this.maxsnapshots, +this.status);
            if (action.error.type) {
                // TODO: Manage error
            }
            this.$store.commit('setReload', true);
            this.$store.commit('closeHovers');
            this.$store.commit('resetSelected');
        }
    },
    beforeDestroy() {
        this.setIsPrompt(false);
    },
    components: { InfoIcon }
};
</script>
